import React, { Component } from 'react';

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;

export default class TextSearch extends Component {
    constructor(props) {
        super();

        var initialValue = '';
        if (props.value){
            initialValue = props.value;
        }

        this.state = {
            value: initialValue,
        };
    }

    componentWillMount() {
        this.timer = null;
    }

    handleChange(value) {

        clearTimeout(this.timer);

        this.setState({ value:value });

        this.timer = setTimeout(this.triggerChange.bind(this), WAIT_INTERVAL);
    }

    handleKeyDown(e) {
        if (e.keyCode === ENTER_KEY) {
            this.triggerChange();
        }
        if (this.props.noSpace && e.keyCode === 32) {
            e.preventDefault();
            return false;
        }
    }

    triggerChange() {
        const { value } = this.state;

        this.props.onChange &&
        this.props.onChange(value);
    }

    render() {
        const { className,disabled,width,marginBottom } = this.props;

        let isDisabled = false;
        if(disabled !== undefined){
            isDisabled = disabled;
        }

        return (
            <input  style={{width: width, marginBottom: marginBottom}}
                    type="text"
                    className={className}
                    value={this.state.value}
                    onChange={(event)=>this.handleChange(event.target.value)}
                    onKeyDown={(event)=>this.handleKeyDown(event)}
                    disabled={isDisabled}
            />
        );
    }
}